// extracted by mini-css-extract-plugin
export default {"addToCartControl":"RY-z","giftCard":"SY-z","btnContainer":"TY-z","cartButton":"UY-z","disabled":"VY-z"};